<p class="text-base">{{ config.data!.message | translate }}</p>

<sh-button
    slot="footer"
    color="secondary"
    icon="arrow-line-left-s"
    iconPosition="left"
    size="max-content"
    [label]="config.data!.reject | translate"
    (clicked)="onClose()"
/>
<sh-button
    slot="footer"
    color="primary"
    size="max-content"
    [label]="config.data!.confirm | translate"
    (clicked)="onClose('Confirmed')"
/>
